import { Card, CardContent, CardDescription, CardHeader, CardTitle, Stack, Text } from '@careflux/primitives';
import { useEffect, useState } from 'react';
import { ComparisonDetailDialog } from './ComparisonDetailDialog';
import { ComparisonsPagination } from './ComparisonsPagination';
import { ComparisonsTable } from './ComparisonsTable';
import { QueryState } from './QueryState';
import type { SummaryComparisonsProps } from './components.types';
import { emptyStateClasses } from './summaryQuality.styles';
import { useComparisonPage } from './useSummaryQualityQueries';

export const SummaryComparisons = ({ dateRange }: SummaryComparisonsProps) => {
  const [page, setPage] = useState(1);
  const [selectedAudioId, setSelectedAudioId] = useState<number | null>(null);
  const pageQuery = useComparisonPage(page, dateRange);
  const data = pageQuery.data;

  // A date range change invalidates whatever page the user was on.
  useEffect(() => setPage(1), [dateRange.from, dateRange.to]);

  return (
    <Card padding="lg">
      <CardHeader>
        <CardTitle>Samanburður samantekta</CardTitle>
        <CardDescription>AI útgáfa á móti vistaðri útgáfu. Hver skoðun er skráð í aðgerðaskrá.</CardDescription>
        <Text size="sm" color="muted">
          Fylgir eingöngu dagsetningarbilinu að ofan – ekki er hægt að sía eftir stofnun, notanda eða líkani.
        </Text>
      </CardHeader>
      <CardContent>
        <QueryState
          isLoading={pageQuery.isLoading}
          isError={pageQuery.isError}
          error={pageQuery.error}
          onRetry={() => void pageQuery.refetch()}
          loadingLabel="Sæki samanburð"
          errorTitle="Samanburður hlóðst ekki"
        />
        {data && data.items.length === 0 && <div className={emptyStateClasses}>Engar samantektir til staðar.</div>}
        {data && data.items.length > 0 && (
          <Stack gap="md">
            <ComparisonsTable items={data.items} onView={setSelectedAudioId} />
            <ComparisonsPagination
              page={data.page}
              totalPages={data.totalPages}
              totalCount={data.totalCount}
              shownCount={data.items.length}
              onPageChange={setPage}
            />
          </Stack>
        )}
      </CardContent>
      <ComparisonDetailDialog audioId={selectedAudioId} onClose={() => setSelectedAudioId(null)} />
    </Card>
  );
};
